import { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import * as api from '../../api';
import formStyles from '../FormStart/index.module.css';
import styles from './index.module.css';

import Loader from '../../components/Loader';
import NavBar, { View } from '../../components/NavBar';

import { isEnumMember } from 'common/dist/utils/types';
import { getParamFromLocationSearch } from '../../utils/navigation';

enum IntentStatus {
  Loading = 'LOADING',
  DONE = 'DONE',
  Error = 'ERROR',
}

const getKind = (source: string) => {
  const sourceUpper = source.toUpperCase();
  if (!isEnumMember(api.PatientNotification.Kind, sourceUpper)) {
    throw Error(`unknown source kind: ${sourceUpper}`);
  }
  return sourceUpper;
};

const Intent: React.FC = () => {
  const history = useHistory();
  const searchParam = history.location.search;
  const source = getParamFromLocationSearch(searchParam, 'source');
  const phoneNumber = getParamFromLocationSearch(searchParam, 'phoneNumber');
  const email = getParamFromLocationSearch(searchParam, 'email');
  const { intentId } = useParams<{ intentId: string }>();
  const [message, setMessage] = useState('');
  const [intentStatus, setIntentStatus] = useState<IntentStatus>(
    IntentStatus.Loading,
  );
  const onError = () => {
    setMessage('We were unable to automatically process your request.');
    setIntentStatus(IntentStatus.Error);
  };
  const onSuccess = (message: string) => {
    setMessage(message);
    setIntentStatus(IntentStatus.DONE);
  };

  useEffect(() => {
    async function processIntent() {
      if (![IntentStatus.Loading, IntentStatus.Error].includes(intentStatus)) {
        return;
      }
      if (!intentId || !source || !(email || phoneNumber)) {
        onError();
        return;
      }
      try {
        const { message } = await api.client.NotificationIntent.postIntent({
          intentId,
          kind: getKind(source),
          email,
          phoneNumber,
        });
        onSuccess(message);
      } catch {
        onError();
      }
    }
    processIntent();
  }, [intentId, setIntentStatus, source, phoneNumber, email, intentStatus]);

  if (intentStatus === IntentStatus.Loading) return <Loader />;
  return (
    <>
      <NavBar view={View.Intent} />
      <div className={formStyles.FormContainer}>
        <div className={formStyles.Form}>
          <p className={styles.Message}>{message}</p>
        </div>
      </div>
    </>
  );
};

export default Intent;
